import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sts-custom-content',
  templateUrl: 'custom-content.component.html'  
})
export class CustomContentComponent implements OnInit {

  @Input()
  title: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/custom-content/custom-content.component.ts